import {
  Box,
  // eslint-disable-next-line no-restricted-imports
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AuthUIContainer } from 'src/components/templates/AuthUIContainer';
import MarketingPageHeader from 'src/features/MP/components/organisms/MarketingPageHeader';
import MarketingPageFooter from 'src/features/MP/components/organisms/MarketingPageFooter';
import { StickyRibbon } from 'src/components/atoms/StickyRibbon';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export const MarketingPageContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  const handleSignUpClick = () => {
    navigate('/register');
  };

  return (
    <>
      <ScrollToTop />
      <Box bg="white">
        <Modal
          isOpen={isAuthModalOpen}
          onClose={() => setIsAuthModalOpen(false)}
          isCentered
          size="md">
          <ModalOverlay />
          <ModalContent borderRadius="4px" bg="surface.card">
            <ModalCloseButton />
            <ModalBody>
              <AuthUIContainer />
            </ModalBody>
          </ModalContent>
        </Modal>
        <MarketingPageHeader
          onLoginClick={() => setIsAuthModalOpen(true)}
          onSignUpClick={handleSignUpClick}
        />
        {children}
        <MarketingPageFooter />
        <StickyRibbon />
      </Box>
    </>
  );
};
